/**
 * Nudges the service worker to re-read what the app has just written to
 * IndexedDB. It reads on its own schedule too, so a lost message only delays a
 * change by a few seconds.
 */
export function notifyServiceWorker(
  type: 'browse-cache-changed' | 'browse-cache-cleared' | 'cached-maps-changed',
): void {
  navigator.serviceWorker?.controller?.postMessage({ type });
}
